import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useUtilityStore } from 'src/stores/useMobxStores';
import { Dialog } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { XButton, DialogHeader } from './styledComponents';


const ModalContainer = () => {
  const utilityStore = useUtilityStore();
  const modelProps = {
    isBlocking: false,
    styles: { main: {width: '500px', maxWidth: 'max-content !important', height: 'max-content' }, inner: { padding: '0px' } }
  };
  const dialogContentProps = {
    styles: { inner: { padding: '0px !important' }, header: { display: 'none' } }
  };

  return (
    <Dialog
      hidden={!utilityStore.modal.open}
      dialogContentProps={dialogContentProps}
      onDismiss={utilityStore.closeModal}
      modalProps={modelProps}
      >
      <DialogHeader>
        <XButton onClick={utilityStore.closeModal}>
          <FontAwesomeIcon icon={faTimes} />
        </XButton>
      </DialogHeader>
      {utilityStore.modal.body}
    </Dialog>
  );
};

export default observer(ModalContainer);
